import React from "react";
import MarketplaceLayout from "../../layouts/MarketplaceLayout";
import DentalProfessionals from "./DentalProfessionals";

export default function DentalProfessionalsmain() {
  return (
    <MarketplaceLayout>
      <DentalProfessionals />
    </MarketplaceLayout>
  );
}